import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'danger';

const TONES: Record<Tone, string> = {
  info: 'border-border bg-tint text-foreground',
  success: 'border-success bg-[var(--success-bg)] text-foreground',
  danger: 'border-danger bg-danger-soft text-[var(--danger-dark)]',
};

/** Сообщение под формой: итог действия или ошибка API (код → текст из словаря). */
export function Notice({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <p
      role={tone === 'danger' ? 'alert' : 'status'}
      className={`rounded-sm border px-3 py-2 text-sm ${TONES[tone]}`}
    >
      {children}
    </p>
  );
}
